// extracted by mini-css-extract-plugin
module.exports = {"biShareDiv":"share-tooltip_biShareDiv___BGfQ","biShare":"share-tooltip_biShare__PYA8C","share":"share-tooltip_share__07e0e","shareText":"share-tooltip_shareText__rJouv"};